module.exports = __webpack_public_path__ + "img/about-1.d710897a.png";